import React from 'react';
import { css } from 'emotion';
import PropTypes from 'prop-types';
import RIEBase from 'components/core/editable/RIEBase';
import ReactDOM from 'react-dom';
import MessageBox from 'components/core/MessageBox';

/**
 * Modified from https://github.com/kaivi/riek, v1.1.0
 */
export default class RIEToggle extends RIEBase {

    static propTypes = {
        textTrue: PropTypes.string,
        textFalse: PropTypes.string,
        radioGroupName: PropTypes.string,
        normalComponentTextOnly: PropTypes.bool, //in normal read only view only display text, no radio buttons for cleaner view in table
        toggleNoWarning: PropTypes.bool, //show warning to user that if the switch the toggle to no, they will lose saved values
        noWrap: PropTypes.bool
    };

    static defaultProps = {
        noWrap: true
    };

    radioClick = (event) => {
        const newValue = (event.target.value === 'Yes');
        this.setState({ newValue });
    };

    /**
     * Have to override parent class method so we can default the state to the correct value
     * @param event
     */
    startEditing = (e) => {
        // do nothing when right mouse button pressed
        if (e.nativeEvent.which === 3) return;

        // do nothing if component is disabled
        if (this.props.isDisabled) return;

        if (this.props.beforeStart) this.props.beforeStart();

        // Get the correct value based on what the user clicked on
        const newState = { editing: true };

        if (e.target.value === 'Yes') {
            newState.newValue = true;

        } else if (e.target.value === 'No') {
            newState.newValue = false;
        }
        this.setState(newState);

        if (this.props.afterStart) this.props.afterStart();
    };

    getLabels = () => {
        return {
            yes: this.props.textTrue || 'Yes',
            no: this.props.textFalse || 'No',
            group: this.props.radioGroupName || 'radios'
        };
    };

    elementBlur = (e) => {
        const componentArea = ReactDOM.findDOMNode(this.refs.container);

        //explicitOriginalTarget for firefox/safari on mac
        const clickedElement = e.relatedTarget || e.nativeEvent.explicitOriginalTarget || document.activeElement;
        if (!componentArea.contains(clickedElement)) {
            this.finishEditing();
        }

        //fix for firefox/safari on mac
        if (e.nativeEvent.explicitOriginalTarget) {
            setTimeout(() => {
                componentArea.focus();
            }, 0);
        }
    };

    renderToggleNoWarning = () => {
        //if currently toggled to yes, show warning that toggling to no will lose values
        if (this.props.value) {
            return (
                <MessageBox includeIcon small className={css`width:250px;`}>
                    Selecting 'No' will remove any set values for this parameter
                </MessageBox>
            );
        }
    };

    renderReadComponent = () => {
        const value = this.getNewValue();
        const labels = this.getLabels();

        if (this.props.normalComponentTextOnly) {
            const displayText = value ? labels.yes : labels.no;
            // add onFocus back in order to go into edit mode via tab key then refactor RIE base so context menu will still work
            // onFocus={this.startEditing}
            return (
                <span
                    className={this.makeClassString()}
                    {...this.getStartEditingProps()}
                    {...this.props.defaultProps}
                >
                    {displayText}
                </span>
            );
        } else {
            return this.renderNormalComponent();
        }
    };

    renderNormalComponent = () => {
        const value = this.getNewValue();
        const labels = this.getLabels();
        const radioClass = this.props.noWrap ? css`white-space: nowrap;` : '';

        return (
            <div
                className={`rie-radio ${radioClass} ${this.makeClassString()}`}
                {...this.getStartEditingProps()}
                {...this.props.editProps}
            >
                <span className="toggle-option">
                    <input
                        type="radio"
                        name={labels.group}
                        ref="input"
                        value={'Yes'}
                        checked={value}
                        tabIndex="1"
                        onChange={this.radioClick}
                        disabled={this.props.isDisabled}
                    />
                    <span className="radio-label">{labels.yes}</span>
                </span>
                <span className="toggle-option">
                    <input
                        type="radio"
                        name={labels.group}
                        value={'No'}
                        checked={value !== '' && !value}
                        tabIndex="1"
                        onChange={this.radioClick}
                        disabled={this.props.isDisabled}
                    />
                    <span className="radio-label">{labels.no}</span>
                </span>
            </div>
        );
    };

    renderEditingComponent = () => {
        const value = this.getNewValue();
        const yesLabel = this.props.textTrue || 'Yes';
        const noLabel = this.props.textFalse || 'No';
        const groupName = this.props.radioGroupName || 'radios';

        return (
            <div className={`radio-wrapper rie-radio ${this.makeClassString()}`}
                {...this.props.editProps}
            >
                <span className="toggle-option">
                    <input
                        type="radio"
                        name={groupName}
                        ref="input"
                        value={'Yes'}
                        checked={value}
                        tabIndex="1"
                        onChange={this.radioClick}
                    />
                    <span className="radio-label">{yesLabel}</span>
                </span>
                <span className="toggle-option">
                    <input
                        type="radio"
                        name={groupName}
                        value={'No'}
                        checked={value !== '' && !value}
                        tabIndex="1"
                        onChange={this.radioClick}
                    />
                    <span className="radio-label">{noLabel}</span>
                </span>
                {this.props.toggleNoWarning && this.renderToggleNoWarning()}
            </div>
        );
    };

}



// WEBPACK FOOTER //
// ./src/components/core/editable/RIEToggle.js